<template>
    <div class="_main">
        <div class="top">
            <div class="bg"></div>
            <div class="part part1">
                <h1>上季榜单</h1>
                <h2>示例为2021Q3榜单</h2>
                <div class="box1_wrap">
                    <div class="box1" v-for="(item,i) in top">
                        <i :class="'top'+(i+1)"></i>
                        <h1>{{item.stockName}}</h1>
                        <p>财报后最大涨幅</p>
                        <h2
                                :class="item.fluctuate.indexOf('-') > -1 ? 'down' : '' ">
                            {{item.fluctuate}}
                        </h2>
                        <p>
                            排名较上期
                            <i :class="item.rankChange < 0 ? 'down_i' : '' "></i>
                            <span :class="item.rankChange < 0 ? 'down' : '' " >
                                {{item.rankChange}}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="part_wrap2">
                <div class="bg2"></div>
                <div class="part part2">
                    <h1>最新入选</h1>
                    <h2>每天更新，有变化就提醒</h2>
                    <div class="box2">
                        <div class="box2_wrap">
                            <div class="item">
                                <h1>{{new2.stockCode}}</h1>
                                <h2>{{new2.stockName}}</h2>
                            </div>
                            <div class="item">
                                <h1>排名变化</h1>
                                <h2>
                                    {{new2.rankNow}}
                                    <i :class="new2.rankBefore - new2.rankNow < 0 ? 'down_i' : '' "></i>
                                    <span :class="new2.rankBefore - new2.rankNow < 0 ? 'down' : '' ">
                                        {{Math.abs(new2.rankBefore - new2.rankNow)}}
                                    </span>
                                </h2>
                            </div>
                            <div class="item">
                                <h1>财报日</h1>
                                <h2>{{formate(new2.pubDate)}} {{new2.reportType}}</h2>
                            </div>
                        </div>
                        <p>入选原因：{{new2.reason}}</p>
                    </div>
                </div>
            </div>

            <div class="part_wrap3">
                <div class="bg3"></div>
                <div class="part part3">
                    <h1>回测收益</h1>
                    <h2>过去十年持续跑赢大盘</h2>
                    <div class="financing_chart">
                        <div id="financing_chart"></div>
                        <div class="chart_time"><span>{{t_s}}</span><span>{{t_e}}</span></div>
                        <div class="left_data">
                            <p>{{max_v}}%</p>
                            <p>{{min_v}}%</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="bot">
            <a :href="'?kind=LBL#AiGuPiao_ThirdPay'" class="btn"></a>
        </div>
    </div>
</template>

<script>
    import "@/utils/flexible2";
    import Api from "@/api/leibaole/index";
    import * as echarts from 'echarts'
    export default {
        name: "not-buy",
        components:{

        },
        data(){
            return{
                top:{},
                new2:{},
                chart:{},
                t_s:'',
                t_e:'',
                max_v:2000,
                min_v:0,
            }
        },
        created(){
            this.getDate();
        },
        methods:{
            async getDate(){
                let res = await Api.BasicRank();
                console.log(res)
                this.top = res.top;
                this.new2 = res.new;
                this.chart = res.chart;
                this.max_v = res.chart.maxValue;
                this.min_v = res.chart.minValue;
                this.chart2();
            },
            formate(str){
                if(str){
                    //04月12日 -- 04-12
                    return str.match(/\d+/g).join('-');
                }
            },
            chart2(){

                var hsNetValue = this.chart.hsNetValue;
                var netValue = this.chart.netValue;
                var xAxisData = this.chart.xAxisData;

                this.t_s = xAxisData[0];
                this.t_e = xAxisData[xAxisData.length - 1];

                function fontSize(res){
                    let docEl = document.documentElement,
                        clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
                    if (!clientWidth) return;
                    let fontSize = (clientWidth / 750);
                    return res*fontSize;

                }

                var option = {
                    grid:{
                        x:30,y:20,x2:0,y2:20
                    },
                    title: {
                        text: '',
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            lineStyle: {
                                color: '#845846',	//显示竖线颜色
                                width: 1,
                            }
                        },
                        textStyle: {
                            color: '#333333',
                            fontSize:fontSize(22),
                        },
                        backgroundColor:'RGBA(253, 250, 247, 1)', //tooltip背景色
                        borderColor:'#A16C38',		//tooltip边框颜色
                        borderWidth:1,
                        formatter: function (param) {	//自定义tooltip内容
                            console.log(param)
                            var text = '';
                            text +=
                                `<div style="padding: ${fontSize(10)}px">
                                    <div style="color:#845846">${param[0].name}</div>
                                    <div style="color:#E8573B;display:flex;align-items: center">
                                        <i style="margin-right: ${fontSize(10)}px;width: ${fontSize(10)}px;height: ${fontSize(10)}px;background: #E8573B;border-radius: 50%"></i>
                                        ${param[1].seriesName}：${param[1].data}%
                                    </div>
                                    <div style="color:#6574F6;display:flex;align-items: center">
                                        <i style="margin-right: ${fontSize(10)}px;width: ${fontSize(10)}px;height: ${fontSize(10)}px;background: #6574F6;border-radius: 50%"></i>
                                        ${param[0].seriesName}：${param[0].data}%
                                    </div>
                                </div>`
                            return text;
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data:xAxisData,
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false,
                        },
                        axisTick: {    // 坐标轴 刻度
                            show: false,  // 是否显示
                        },
                    },
                    yAxis: [
                        {
                            type: 'value',
                            min: this.min_v,
                            max: this.max_v,
                            interval: this.max_v - this.min_v,
                            axisLabel: {
                                textStyle: {
                                    color: '#845846',//坐标值得具体的颜色
                                    fontSize:fontSize(20),
                                },
                                formatter: (value) => {
                                    // if(value == 0){
                                    //     return value+'%      ';
                                    // }
                                    // else{
                                    //     return value+'%';
                                    // }
                                },
                                margin:-70,
                            },
                            //网格样式
                            splitLine: {
                                show: false,
                            }
                        },

                    ],
                    series: [
                        {
                            name: '沪深300',
                            type: 'line',
                            data: hsNetValue,
                            color: "#6574F6",//拐点样式
                            symbolSize:0,
                            lineStyle:{
                                width: 4,
                            }
                        },
                        {
                            name: '基本面50组合',
                            type: 'line',
                            data: netValue,
                            color: "#E8573B",//拐点样式
                            symbolSize:0,
                            lineStyle:{
                                width: 4,
                            }

                        },


                    ]
                };
                var myChart = echarts.init(document.getElementById('financing_chart'));
                myChart.setOption(option);


                setTimeout(function(){
                    myChart.dispatchAction({
                        type: 'showTip',
                        seriesIndex:1,  // 显示第几个series
                        dataIndex:  1500   // 显示靠后的数据
                    });
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/sass/global.scss";
    ._main{
        //background: rgba(83, 7, 8, 0.54);
        min-height: 100vh;
    }
    .top{
        width: 100%;
        //height: rem2(1454px);
        background: linear-gradient(180deg, #DC503F 0%, #A71414 100%);
        position: relative;
        padding: 1px 0;
        .bg{
            width: 100%;
            height: 100%;
            background:url("~@/assets/images/leibaole/bgpic1.png") no-repeat;
            background-size: 100% auto;
            position: absolute;
        }
        .part{
            position: relative;
            >h1{
                font-size: rem2(32px);
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #E8573B;
                line-height: rem2(45px);
                padding: rem2(13px) rem2(50px) rem2(15px);
            }
            >h2{
                position: absolute;
                left: rem2(233px);
                top: rem2(13px);
                font-size: rem2(24px);
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFF0DD;
                line-height: rem2(33px);
            }
        }
        .part1{

            width: rem2(704px);
            height: rem2(292px);
            background:url("~@/assets/images/leibaole/part1.png") no-repeat;
            background-size: 100%;
            margin: rem2(299px) auto rem2(23px);

            .box1_wrap{
                display: flex;
                margin: 0 auto;
                justify-content: center;
                .box1{
                    width: rem2(227px);
                    height: rem2(212px);
                    background:url("~@/assets/images/leibaole/box1.png") no-repeat;
                    background-size: 100%;
                    position: relative;
                    >i{
                        width: rem2(80px);
                        height: rem2(79px);
                        background:url("~@/assets/images/leibaole/top1.png") no-repeat;
                        background-size: 100%;
                        display: block;
                        position: absolute;
                        top: rem2(-17px);
                        left: rem2(-11px);
                    }
                    .top2{
                        background-image: url("~@/assets/images/leibaole/top2.png");
                    }
                    .top3{
                        background-image: url("~@/assets/images/leibaole/top3.png");
                    }
                    >h1{
                        line-height: rem2(45px);
                        font-size: rem2(32px);
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #835644;
                        text-align: center;
                        margin: rem2(25px) 0 rem2(9px);
                    }
                    >p{
                        height: rem2(28px);
                        font-size: rem2(20px);
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #835644;
                        line-height: rem2(28px);
                        text-align: center;
                        >span{
                            color: #E8573B;
                        }
                        >i{
                            width: rem2(18px);
                            height: rem2(20px);
                            background:url("~@/assets/images/leibaole/up.png") no-repeat;
                            background-size: 100%;
                            display: inline-block;
                        }
                        .down_i{
                            background-image: url("~@/assets/images/leibaole/down.png");
                        }
                        .down{
                            color: #19AD7B;
                        }
                    }
                    >h2{
                        text-align: center;
                        font-size: rem2(38px);
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #E8573B;
                        line-height: rem2(53px);
                    }
                    .down{
                        color: #19AD7B;
                    }
                }
            }
        }

        .part_wrap2{
            position: relative;
            width: rem2(704px);
            height: rem2(220px);
            margin: 0 auto rem2(22px);
            .bg2{
                position: absolute;
                width: rem2(94px);
                height: rem2(88px);
                right: rem2(19px);
                top: rem2(5px);
                background:url("~@/assets/images/leibaole/bgpic2.png") no-repeat;
                background-size: 100%;
            }
        }

        .part2{
            position: relative;
            width: rem2(704px);
            height: rem2(220px);
            background:url("~@/assets/images/leibaole/part2.png") no-repeat;
            background-size: 100%;
            margin: 0 auto rem2(22px);
            .box2{
                width: rem2(679px);
                height: rem2(141px);
                background:url("~@/assets/images/leibaole/box2.png") no-repeat;
                background-size: 100%;
                margin: 0 auto;
                padding: rem2(13px) rem2(25px) rem2(20px);
                box-sizing: border-box;
                .box2_wrap{
                    display: flex;
                    .item{
                        width: 33.3%;
                        >h1{
                            height: rem2(28px);
                            font-size: rem2(20px);
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #835644;
                            line-height: rem2(28px);
                        }
                        >h2{
                            font-size: rem2(36px);
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #835644;
                            line-height: rem2(50px);
                            >i{
                                width: rem2(18px);
                                height: rem2(20px);
                                background:url("~@/assets/images/leibaole/up.png") no-repeat;
                                background-size: 100%;
                                display: inline-block;
                                margin-left: rem2(12px);
                                margin-right: rem2(6px);
                            }
                            >span{
                                font-size: rem2(20px);
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #E8573B;
                                line-height: rem2(28px);
                            }
                            .down_i{
                                background-image:url("~@/assets/images/leibaole/down.png");
                            }
                            .down{
                                color: #19AD7B;
                            }
                        }
                    }
                }
                >p{
                    height: rem2(28px);
                    font-size: rem2(20px);
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #835644;
                    line-height: rem2(28px);
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }


        .part_wrap3{
            position: relative;
            width: rem2(704px);
            height: rem2(428px);
            margin: 0 auto rem2(32px);
            .bg3{
                position: absolute;
                width: rem2(94px);
                height: rem2(88px);
                right: rem2(0px);
                top: rem2(-5px);
                background:url("~@/assets/images/leibaole/bgpic3.png") no-repeat;
                background-size: 100%;
            }
        }

        .part3{
            position: relative;
            width: rem2(704px);
            height: rem2(428px);
            background:url("~@/assets/images/leibaole/part3.png") no-repeat;
            background-size: 100%;
            margin: 0 auto rem2(32px);


            .financing_chart{
                position: relative;
            }
            #financing_chart{
                width: rem2(660px);
                height: rem2(300px);
                margin: 0 auto;
            }
            .chart_time{
                width: rem2(650px);
                margin: 0 auto;
                height: rem2(28px);
                font-size: rem2(20px);
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #845846;
                line-height: rem2(28px);
                display: flex;
                justify-content: space-between;
            }
            .left_data{
                font-weight: 400;
                color: #845846;
                position: absolute;
                left: rem2(5px);
                top: 0;
                font-size: rem2(20px);
                height: rem2(290px);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
        }
    }
    .bot{
        width: 100%;
        padding: rem2(16px) 0;
        background: rgba(83, 7, 8, 0.54);
        .btn{
            height: rem2(109px);
            width: rem2(704px);
            margin: 0 auto;
            background: url("~@/assets/images/leibaole/download.png") no-repeat ;
            background-size: 100%;
            display: block;
        }
    }
</style>